import { render, staticRenderFns } from "./ProductPayType.vue?vue&type=template&id=505c3b8b&scoped=true&"
import script from "./ProductPayType.vue?vue&type=script&lang=js&"
export * from "./ProductPayType.vue?vue&type=script&lang=js&"
import style0 from "./ProductPayType.vue?vue&type=style&index=0&id=505c3b8b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505c3b8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCard,VDivider,VListItem,VListItemContent,VRadio,VRadioGroup})
